const SITE_URL = 'https://trufflehuntingoregon.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/apple-touch-icon.svg`;

function ensureMeta(selector: string, factory: () => HTMLMetaElement): HTMLMetaElement {
  const existing = document.head.querySelector(selector);
  if (existing instanceof HTMLMetaElement) {
    return existing;
  }
  const el = factory();
  document.head.appendChild(el);
  return el;
}

function setNamedMeta(name: string, content: string) {
  const el = ensureMeta(`meta[name="${name}"]`, () => {
    const meta = document.createElement('meta');
    meta.setAttribute('name', name);
    return meta;
  });
  el.setAttribute('content', content);
}

function setPropertyMeta(property: string, content: string) {
  const el = ensureMeta(`meta[property="${property}"]`, () => {
    const meta = document.createElement('meta');
    meta.setAttribute('property', property);
    return meta;
  });
  el.setAttribute('content', content);
}

function setCanonical(url: string) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!(link instanceof HTMLLinkElement)) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
}

function setJsonLd(id: string, graph: Record<string, unknown>) {
  const selector = `script[data-seo-id="${id}"]`;
  let script = document.head.querySelector(selector);
  if (!(script instanceof HTMLScriptElement)) {
    const nextScript = document.createElement('script');
    nextScript.type = 'application/ld+json';
    nextScript.dataset.seoId = id;
    document.head.appendChild(nextScript);
    script = nextScript;
  }
  script.textContent = JSON.stringify(graph);
}

function clearJsonLd(id: string) {
  document.head.querySelector(`script[data-seo-id="${id}"]`)?.remove();
}

export function setPageSeo({
  title,
  description,
  path,
  robots = 'index,follow,max-image-preview:large',
  type = 'website',
  jsonLd,
}: {
  title: string;
  description: string;
  path: string;
  robots?: string;
  type?: string;
  jsonLd?: Record<string, unknown>;
}) {
  const url = new URL(path, SITE_URL).toString();
  document.title = title;
  setCanonical(url);
  setNamedMeta('description', description);
  setNamedMeta('robots', robots);
  setNamedMeta('twitter:title', title);
  setNamedMeta('twitter:description', description);
  setNamedMeta('twitter:image', DEFAULT_OG_IMAGE);
  setPropertyMeta('og:type', type);
  setPropertyMeta('og:url', url);
  setPropertyMeta('og:title', title);
  setPropertyMeta('og:description', description);
  setPropertyMeta('og:image', DEFAULT_OG_IMAGE);

  if (jsonLd) {
    setJsonLd('page', jsonLd);
  } else {
    clearJsonLd('page');
  }
}
